"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironmentOpcodeTemplates = getEnvironmentOpcodeTemplates;
function getEnvironmentOpcodeTemplates() {
    return `
                        // Environment Operations
                        case opMap[210]: { // CREATE_ENV
                            // Create a new child environment
                            // Stack top should have parent environment
                            let parentEnv = stack.pop();
                            let newEnv = {
                                vars: {},
                                constVars: {},  // Track const variables for immutability
                                tdzVars: {},    // BUG FIX #544: Track variables in Temporal Dead Zone
                                parent: parentEnv
                            };
                            // Make this the current environment
                            env = newEnv;
                            pc++;
                            break;
                        }

                        case opMap[211]: { // LOAD_FROM_ENV
                            // Load variable from environment chain
                            let varName = constants[arg];
                            let currentEnv = env;
                            let value;
                            let found = false;

                            // BUG FIX #544, #370: Check TDZ and vars together at each level
                            // Walk the chain checking both tdzVars and vars at each environment.
                            // If we find the variable in tdzVars BEFORE we find it in vars, throw TDZ error.
                            // If we find it in vars first (or same level), the variable is initialized.
                            // This correctly handles shadowed variables where inner let shadows outer TDZ.
                            while (currentEnv) {
                                // Check if variable is in TDZ at this level
                                if (currentEnv.tdzVars && varName in currentEnv.tdzVars) {
                                    throw new ReferenceError("Cannot access '" + varName + "' before initialization");
                                }
                                // Check if variable exists at this level
                                if (varName in currentEnv.vars) {
                                    value = currentEnv.vars[varName];
                                    found = true;
                                    break;
                                }
                                currentEnv = currentEnv.parent;
                            }


                            if (!found) {
                                // Variable not in environment chain, fall back to global scope
                                // Check in order:
                                // 1. VM globals (__vmGlobals__)
                                // 2. Node.js module-scoped variables (module, exports, require, __filename, __dirname)
                                // 3. Actual global object (for browser/Node.js built-ins)
                                if (varName in {vmGlobalsName}) {
                                    value = {vmGlobalsName}[varName];
                                } else if ({vmModuleVarsName} && varName in {vmModuleVarsName}) {
                                    value = {vmModuleVarsName}[varName];
                                } else {
                                    value = (typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : global))[varName];
                                }
                            }
                            stack.push(value);
                            pc++;
                            break;
                        }

                        case opMap[212]: { // STORE_TO_ENV
                            // Store variable in environment chain (or create in current env if not found)
                            let varName = constants[arg];
                            let value = stack.pop(); // Pop the value

                            let currentEnv = env;
                            let found = false;

                            // Search up the environment chain
                            // Use 'in' operator instead of hasOwnProperty for better performance
                            while (currentEnv) {
                                if (varName in currentEnv.vars) {
                                    // Check if this is a const variable
                                    if (currentEnv.constVars && varName in currentEnv.constVars) {
                                        throw new TypeError('Assignment to constant variable.');
                                    }
                                    // BUG FIX #564: Remove from TDZ when initialized
                                    if (currentEnv.tdzVars && varName in currentEnv.tdzVars) {
                                        delete currentEnv.tdzVars[varName];
                                    }
                                    currentEnv.vars[varName] = value;
                                    found = true;
                                    break;
                                }
                                currentEnv = currentEnv.parent;
                            }

                            // If not found in chain, create in current environment
                            if (!found) {
                                // BUG FIX #564: Remove from TDZ when initialized
                                if (env.tdzVars && varName in env.tdzVars) {
                                    delete env.tdzVars[varName];
                                }
                                env.vars[varName] = value;
                            }
                            pc++;
                            break;
                        }

                        case opMap[213]: { // GET_ENV
                            // Push current environment onto stack
                            stack.push(env);
                            pc++;
                            break;
                        }

                        case opMap[214]: { // RESTORE_PARENT_ENV
                            // Restore parent environment
                            if (env && env.parent) {
                                env = env.parent;
                            }
                            pc++;
                            break;
                        }

                        case opMap[215]: { // STORE_TO_CURRENT_ENV
                            // Store variable in CURRENT environment only (no parent chain search)
                            // Used for per-iteration loop bindings to shadow parent variables
                            let storeName = constants[arg];
                            let storeValue = stack.pop();

                            // BUG FIX #564, #370: Remove from TDZ when initialized
                            // Clear both the scoped name (e.g., 'x$$2') and the base name ('x')
                            // This handles shadowed variables where DECLARE_TDZ uses the raw name
                            // but STORE uses the scoped name
                            if (env.tdzVars) {
                                if (storeName in env.tdzVars) {
                                    delete env.tdzVars[storeName];
                                }
                                // Also clear the base name if this is a scoped name
                                let baseName = storeName.split('$$')[0];
                                if (baseName !== storeName && baseName in env.tdzVars) {
                                    delete env.tdzVars[baseName];
                                }
                            }
                            env.vars[storeName] = storeValue;
                            pc++;
                            break;
                        }

                        case opMap[216]: { // STORE_TO_ENV_CONST
                            // Store const variable in environment chain (mark as immutable)
                            // This opcode is used for DECLARING const variables in the environment
                            let constName = constants[arg];
                            let constValue = stack.pop();
                            let constEnv = env;
                            let constFound = false;

                            // Search up the environment chain
                            // Use 'in' operator instead of hasOwnProperty for better performance
                            while (constEnv) {
                                if (constName in constEnv.vars) {
                                    // Found variable in environment chain
                                    // Check if it's already const - if so in parent, we're shadowing (allowed)
                                    if (constEnv.constVars && constName in constEnv.constVars) {
                                        // It's const in parent or current - don't update parent const (shadowing)
                                        // Create new variable in current environment instead
                                        break;
                                    }
                                    // Variable exists but not const - update it and mark as const
                                    constEnv.vars[constName] = constValue;
                                    // Mark as const
                                    if (!constEnv.constVars) {
                                        constEnv.constVars = {};
                                    }
                                    constEnv.constVars[constName] = true;
                                    constFound = true;
                                    break;
                                }
                                constEnv = constEnv.parent;
                            }

                            // If not found in chain (or found const in parent), create in current environment and mark as const
                            if (!constFound) {
                                // BUG FIX #544: Remove from TDZ when initialized
                                if (env.tdzVars && constName in env.tdzVars) {
                                    delete env.tdzVars[constName];
                                }
                                env.vars[constName] = constValue;
                                if (!env.constVars) {
                                    env.constVars = {};
                                }
                                env.constVars[constName] = true;
                            }
                            pc++;
                            break;
                        }

                        case opMap[217]: { // STORE_TO_CURRENT_ENV_CONST
                            // Store const variable in CURRENT environment only (no parent chain search)
                            // Used for per-iteration loop bindings with const
                            let currentConstName = constants[arg];
                            let currentConstValue = stack.pop();

                            // Check if already exists as const in current environment
                            if (env.constVars && env.constVars[currentConstName]) {
                                throw new TypeError('Assignment to constant variable.');
                            }

                            // BUG FIX #544, #370: Remove from TDZ when initialized
                            // Clear both the scoped name (e.g., 'x$$2') and the base name ('x')
                            if (env.tdzVars) {
                                if (currentConstName in env.tdzVars) {
                                    delete env.tdzVars[currentConstName];
                                }
                                let currentConstBaseName = currentConstName.split('$$')[0];
                                if (currentConstBaseName !== currentConstName && currentConstBaseName in env.tdzVars) {
                                    delete env.tdzVars[currentConstBaseName];
                                }
                            }

                            // Store in current environment and mark as const
                            env.vars[currentConstName] = currentConstValue;
                            if (!env.constVars) {
                                env.constVars = {};
                            }
                            env.constVars[currentConstName] = true;
                            pc++;
                            break;
                        }

                        case opMap[218]: { // DECLARE_TDZ
                            // BUG FIX #544: Declare variable in Temporal Dead Zone
                            // This is emitted before const/let declarations to mark them as in TDZ
                            let tdzVarName = constants[arg];
                            if (!env.tdzVars) {
                                env.tdzVars = {};
                            }
                            env.tdzVars[tdzVarName] = true;
                            pc++;
                            break;
                        }
    `;
}
